import { Transition } from "@headlessui/react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { fetchReal } from "../utils/fetch";

function SongSearch() {
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);

  const searchRef = useRef();

  const handleSearch = () => {
    setLoading(true);
    const search = searchRef.current.value;
    fetchReal("/songs/search?q=" + search, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setResults(data.results);
          searchRef.current.value = "";
          setLoading(false);
        } else {
          setResults("There was an error, please try again in a few minutes.");
          setLoading(false);
        }
      });
  };

  return (
    <div className="tw-w-full">
      <div
        className={`${
          results ? `tw-rounded-b-none` : ``
        } tw-flex tw-w-full tw-flex-row tw-items-center tw-justify-center tw-appearance-none tw-rounded-md tw-shadow-lg tw-border tw-border-slate-900 sm:tw-w-3/4 sm:tw-ml-6 tw-mt-2 sm:tw-mr-6`}
      >
        <input
          type="text"
          ref={searchRef}
          onFocus={() => setResults(null)}
          className="tw-appearance-none tw-w-full tw-bg-white tw-px-3 tw-py-2 tw-rounded-md tw-text-sky-700 tw-leading-tight focus:tw-outline-none focus:tw-bg-white focus:tw-border-gray-500"
          placeholder="Enter a keyword to search for a song (eg. bekhayali, dhanush, 2018)..."
        />
        <button
          onClick={handleSearch}
          className="tw-float-right tw-rounded-md tw-p-2 tw-bg-sky-700 tw-text-white tw-mt-1 tw-mb-1 tw-mr-1"
        >
            {!loading && <MagnifyingGlassIcon className="tw-w-6 tw-h-6 tw-mx-1" />}
            {loading && (
              <svg
                role="status"
                className="tw-w-6 tw-h-6 tw-text-gray-200 tw-animate-spin tw-fill-sky-500"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                ></path>
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                ></path>
              </svg>
            )}
        </button>
      </div>
      <Transition
        show={results === null ? false : true}
        className="tw-w-full"
        as="div"
        enter="tw-transition tw-ease-out tw-duration-100"
        enterFrom="tw-transform tw-opacity-0 tw-scale-95"
        enterTo="tw-transform tw-opacity-100 tw-scale-100"
        leave="tw-transition tw-ease-in tw-duration-75"
        leaveFrom="tw-transform tw-opacity-100 tw-scale-100"
        leaveTo="tw-transform tw-opacity-0 tw-scale-95"
      >
        <div className="tw-absolute sm:tw-relative tw-z-30 tw-flex tw-w-2/3 tw-flex-col tw-rounded-t-none tw-rounded tw-shadow-lg sm:tw-ml-6 tw-mb-2 tw-bg-white tw-mt-1 tw-border tw-border-slate-900">
          {results && (
            <>
              <div className="tw-m-3">
                {results.length > 0 ? (
                  results.map((result) => (
                    <div
                      key={result.id}
                      className="tw-group tw-p-3 tw-flex tw-flex-row tw-w-full tw-items-center tw-justify-between tw-text-sm tw-text-gray-600 hover:tw-cursor-pointer"
                    >
                      <Link
                        to={`/${result.songLang.toLowerCase()}/${
                          result.id
                        }/${result.songName
                          .toLowerCase()
                          .split(" ")
                          .join("-")}/${
                          result.carnaticVersion !== "Not Available"
                            ? "carnatic"
                            : result.bandVersion !== "Not Available"
                            ? "band"
                            : result.westernVersion !== "Not Available" &&
                              "western"
                        }`}
                        className="tw-flex tw-flex-col tw-items-start tw-w-full tw-text-left tw-border-b-2"
                      >
                        <div className="tw-transition-all tw-text-left tw-ease-in-out tw-duration-300 tw-text-2xl tw-text-sky-700 group-hover:tw-text-sky-800 group-hover:tw-underline group-hover:tw-decoration-sky-800">
                          {result.songName}
                        </div>
                        <div className="tw-grid tw-grid-rows-3">
                          <div className="tw-font-bold tw-text-black">
                            From{" "}
                            <span className="tw-text-left tw-text-gray-600 tw-font-normal">
                              {result.movieName}
                            </span>
                          </div>
                          <div>
                            {result.artistName && (
                              <>
                                <span className="tw-font-bold tw-text-black">
                                  By{" "}
                                </span>
                                <span className="tw-text-left tw-text-gray-600 tw-font-normal">
                                  {result.artistName}
                                </span>
                              </>
                            )}
                          </div>
                          <div>
                            {result.yearReleased && (
                              <>
                                <span className="tw-font-bold tw-text-black">
                                  Released in{" "}
                                </span>
                                <span className="tw-text-left tw-text-gray-600 tw-font-normal">
                                  {result.yearReleased}
                                </span>
                              </>
                            )}
                          </div>
                        </div>
                        <div className="tw-text-sm tw-text-gray-600 tw-text-left"></div>
                      </Link>
                    </div>
                  ))
                ) : (
                  <p className="tw-text-center tw-text-gray-400 tw-font-semibold">
                    No results :{"("}
                  </p>
                )}
              </div>
            </>
          )}
        </div>
      </Transition>
    </div>
  );
}

export default SongSearch;
